import React from "react";
import SlimContainer from "@widgets/layout/SlimContainer";
import EmployeeDetailsCard from "@widgets/employees/editor/sections/EmployeeDetailsCard";
import ClockedHoursOverview from "@widgets/employees/editor/timeEntries/ClockedHoursOverview";
import {SetEmployeeProps} from "@pages/authenticated/admin/employees/Employee";
import {Icon, TabControl, TabControlButton, TabControlPage} from "peggirkit";
import {useIntl} from "react-intl";
import {ClockIcon, UserCircleIcon} from "@heroicons/react/24/outline";

type Props = SetEmployeeProps & {
    initialLoading: boolean,
};

const EmployeeSectionTabs = ({initialLoading, employee, setEmployee}: Props) => {
    const intl = useIntl();
    return (
        <TabControl
            containerClassname={"mt-6 md:mt-12"}
            tabPanelsContainerClassname={"pt-12"}
            tabsListStyle={{type: "select-list"}}
            breakpoints={{md: {tabsListStyle: {type: "button-row"}}}}
        >
            <TabControlPage
                tabButton={
                    <TabControlButton iconBefore={<Icon icon={UserCircleIcon}/>}>
                        {intl.formatMessage({id: "general"})}
                    </TabControlButton>
                }
                unmount={true}
                disabled={initialLoading}
            >
                <SlimContainer center={false}>
                    <EmployeeDetailsCard
                        employee={employee}
                        setEmployee={setEmployee}
                        initialLoading={initialLoading}
                    />
                </SlimContainer>
            </TabControlPage>

            {
                employee
                    ? <TabControlPage
                        tabButton={
                            <TabControlButton iconBefore={<Icon icon={ClockIcon}/>}>
                                {intl.formatMessage({id: "timeRegistration"})}
                            </TabControlButton>
                        }
                        unmount={true}
                        disabled={initialLoading}
                    >

                        {employee && <ClockedHoursOverview employee={employee}/>}
                    </TabControlPage>
                    : <></>
            }
        </TabControl>
    );
};

export default EmployeeSectionTabs;